import { Module } from "vuex";
import setProp from "../../setProp";
import { Client } from "@/shared/model/client.model";
import Currencies from "@/shared/constants/currencies.constants";



export const gameStore: Module<any, any> = {
  
  state: {
    gameData: null, // 360 ou ESG
    encryptedManagerId: null,
    currency: Currencies.EUR.value,
    client: new Client(),
    

    navClient: {
      lang: null,
      logoUrl: "/content/images/360/odonatech_logo.jpeg",
      logoEsg: "/content/images/360/OdoESG.png",
      managerName: null,
      offer: null,
      personalized: "#00008F",
    },
    chocolate: {
      logo: "https://odo-logo.s3.eu-west-3.amazonaws.com/sigle-odo-blue.png",
      bgColor: "#fff",
      buttonsColor: "#004FD4",
      advisorName: "Clémence",
      picture: "https://odo-logo.s3.eu-west-3.amazonaws.com/clemence_chocolate.png",
      gender: "F",
      companyName: "Odonatech",
      customMsg:null,
    },
    encryptedGameId: null,
    esgLink: null,
    onPublicLink: false,
    moneyGameBoard: null,
    constants: {
      backOfficeUrl: null,
      profileUrl: null
    },
    sequenceModulableCheat: null,

    // ODOPRO //
    odopro: {
      controller: null,
      courseData: {
        id: null,
        lastLocation: {
          chapter: null,
          page: null,
        },
        timeSpent: null,
        progress: null,
        startDate: null,
        endDate: null,
        lastModificationDate: null,
        userId: null,
        gameData: {
          id: null,
          gmeStep: null,
        },
      },
      chapter_one: null,
      chapter_two: null,
      chapter_three: null,
      certification: null,
      current: {
        chapter: null,
        page: null,
      },
      currentTimeSpent: 0,
    },
  },

  // store.commit
  mutations: {
    setGameData(state, gd) {
      state.gameData = gd;
    },
    setNavClient(state, navClient) {
      state.navClient = navClient;
    },
    setCurrency(state, currency) {
      state.currency = currency;
    },
    sequenceModulableCheat(state, sequence) {
      state.sequenceModulableCheat = sequence;
    },

    // ODOPRO //
    setCourseData(state, data) {
      if (data.courseChapters != null) {
        let numberOfCourseChapters = Object.keys(data.courseChapters).length;
        for (let i = 0; i < numberOfCourseChapters; i++) {
          if (data.courseChapters[i].name.indexOf("C1") != -1) {
            setProp(state, ["odopro", "chapter_one"], data.courseChapters[i]);
          } else if (data.courseChapters[i].name.indexOf("C2") != -1) {
            setProp(state, ["odopro", "chapter_two"], data.courseChapters[i]);
          } else if (data.courseChapters[i].name.indexOf("C3") != -1) {
            setProp(state, ["odopro", "chapter_three"], data.courseChapters[i]);
          } else if (data.courseChapters[i].name.indexOf("C4") != -1) {
            setProp(state, ["odopro", "certification"], data.courseChapters[i]);
          }
        }
      }
      setProp(state, ["odopro", "courseData", "gameData", "id"], data.gameDataId);
      setProp(state, ["odopro", "courseData", "gameData", "gmeStep"], data.gameDataCurrentStep);

      setProp(state, ["odopro", "courseData", "id"], data.id);
      /*       setProp(state, ['odopro', 'courseData', 'lastLocation'], data.lastLocation);
       */ state.odopro.courseData.lastLocation = data.lastLocation;

      setProp(state, ["odopro", "current", "chapter"], state.odopro.courseData.lastLocation.chapter);
      setProp(state, ["odopro", "current", "page"], state.odopro.courseData.lastLocation.page);

      setProp(state, ["odopro", "courseData", "timeSpent"], data.timeSpent);
      setProp(state, ["odopro", "courseData", "startDate"], data.startDate);
      setProp(state, ["odopro", "courseData", "endDate"], data.endDate);
      setProp(state, ["odopro", "courseData", "progress"], data.progress);
      setProp(state, ["odopro", "courseData", "lastModificationDate"], data.lastModificationDate);
      setProp(state, ["odopro", "courseData", "userId"], data.userId);
    },
    setToPro(state) {
      state.odopro.isPro = true;
    },
    updateCourseChapter(state, chapter) {
      if (chapter.name.indexOf("C1") != -1) {
        setProp(state, ["odopro", "chapter_one"], chapter);
      } else if (chapter.name.indexOf("C2") != -1) {
        setProp(state, ["odopro", "chapter_two"], chapter);
      } else if (chapter.name.indexOf("C3") != -1) {
        setProp(state, ["odopro", "chapter_three"], chapter);
      }
    },
    updateCurrentLocation(state, location) {
      setProp(state, ["odopro", "current"], location);
    },
    updateCurrentTimeSpent(state, time) {
      setProp(state, ["odopro", "currentTimeSpent"], time);
    },
    setEncryptedGameId(state, id) {
      state.encryptedGameId = id;
    },
    updateGameData(state, gd) {
      state.gameData = gd;
    },
    setOnPublicLink(state) {
      state.onPublicLink = true;
    },
    setEncryptedManagerId(state, id) {
      state.encryptedManagerId = id;
    },
    setClient(state, client) {
      state.client = client;
    },
    setMoneyGameBoard(state, mgb) {
      state.moneyGameBoard = mgb;
    },
    setYmlConstants(state, constants) {
      state.constants = constants;
    },
    setChocolate(state, chocolate) {
      state.chocolate = chocolate;
    },
    setChocolateCustomMsg(state, customMsg) {
      state.chocolate.customMsg = customMsg;
    },
    setEsgLink(state, link) {
      state.esgLink = link;
    },
  },
  getters: {
    navClient: (state) => state.navClient,
    courseData: (state) => state.odopro.courseData,
    odoProLastLocation: (state) => state.odopro.courseData.lastLocation,
    currentChapter: (state) => (id) => {
      let cname = id + ""; // id is a chapter name, ie 'Chapitre 1'
      if (cname.indexOf("1") != -1) {
        return state.odopro.chapter_one;
      } else if (cname.indexOf("2") != -1) {
        return state.odopro.chapter_two;
      } else if (cname.indexOf("3") != -1) {
        return state.odopro.chapter_three;
      } else {
        return state.odopro.certification;
      }
    },
    currentLocation: (state) => state.odopro.current,
    currentTimeSpent: (state) => state.odopro.currentTimeSpent,
    gameData: (state) => state.gameData,
    encryptedGameId: (state) => state.encryptedGameId,
    onPublicLink: (state) => state.onPublicLink,
    encryptedManagerId: (state) => state.encryptedManagerId,
    persoColor: (state) => state.navClient.personalizedColor,
    client: (state) => state.client,
    currency: (state) => state.currency,
    moneyGameBoard: (state) => state.moneyGameBoard,
    backOfficeUrl: (state) => state.constants.backOfficeUrl,
    profileUrl: (state) => state.constants.profileUrl,
    chocolate: (state) => state.chocolate,
    esgLink: (state) => state.esgLink,
    sequenceModulableCheat: (state) => state.sequenceModulableCheat,
  },
};
